import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Link } from 'react-router-dom';

import { Box, Accordion } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const CardSupplier = styled(Box)(
    ({ theme }: ParamsStyle) => `
    padding: 1px;
    margin-top: 1rem;
    border-radius: 5px;
    background-color: ${theme?.palette.secondary.main};
`);

export const LinkCustom = styled(Link)(
    ({ theme }: ParamsStyle) => `
    display: flex;
    border-radius: 5px;
    background-color: white;
    justify-content: space-between;
    padding: .9375rem .875rem .625rem;
    border: 1.5px solid ${theme?.palette.secondary.main};
    
    svg {
        height: 1.2rem;
        margin-bottom: 4px;

        path {
            fill: ${theme?.palette.primary.main};
        }
    }
`);

export const AccordionCustom = styled(Accordion)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        border-radius: 5px;
        border: 1px solid #8D9BB5;

        &.Mui-expanded {
            margin: 0;
        }
        
        #panel1d-header {
            min-height: 0;
            height: 3.125rem;
            &.Mui-expanded {
                min-height: 0;
            }

            .MuiAccordionSummary-content {
                margin: 0;
                &.Mui-expanded {
                    margin: 0;
                }
            } 
        }

        a {
            width: 100%;
            display: flex;
            font-weight: 700;
            font-size: 1.5625rem;
            padding: 1.625rem 0 1.8125rem;
            justify-content: space-between;
            color: ${theme?.palette.primary.main};
            border-top: 1.5px solid rgba(141, 155, 181, 0.35);

            svg {
                width: 25px;
                height: auto;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 48%;
        }
`);
